export const transformColorDto = color => {
  const {
    id,
    title,
    code,
    hex,
    order
  } = color;
  return {
    id,
    title,
    code,
    hex,
    order
  };
};
export const transformColorDtos = colors => colors.map(transformColorDto);